import { z } from "zod";
import type { Pagination } from "@CommonTypes/backend/pagination";

export const RouteGetCdtTrees_treeId_Items = "/cdt/trees/:treeId/items";

export const QueryGetCdtTreeItemsSchema = z
  .object({
    nodeId: z
      .union([z.literal(""), z.coerce.number().int().positive()])
      .transform((value) => (value === "" ? undefined : value))
      .optional(),
    unassigned: z
      .union([z.literal(""), z.literal("true"), z.literal(true)])
      .transform((value): true | undefined =>
        value === true || value === "true" ? true : undefined,
      )
      .optional(),
    search: z
      .string()
      .trim()
      .transform((value) => (value === "" ? undefined : value))
      .optional(),
    page: z.coerce.number().int().min(1).default(1),
    size: z.coerce.number().int().min(1).max(100).default(10),
  })
  .refine((query) => !(query.nodeId !== undefined && query.unassigned === true), {
    message: "nodeId and unassigned cannot be used together",
    path: ["unassigned"],
  });

export const CdtTreeItemSchema = z.object({
  productId: z.number(),
  nodeId: z.number().nullable(),
  position: z.number(),
  name: z.string().nullable(),
  subcategory: z.string().nullable(),
  segment: z.string().nullable(),
  brand: z.string().nullable(),
  sku: z.string(),
  price: z.number().nullable(),
});

export const ResponseGetCdtTreeItemsSchema = z.object({
  totalRows: z.number(),
  totalPages: z.number(),
  page: z.number(),
  size: z.number(),
  data: z.array(CdtTreeItemSchema),
});

export type QueryGetCdtTreeItems = z.infer<typeof QueryGetCdtTreeItemsSchema>;
export type QueryGetCdtTreeItemsInput = z.input<typeof QueryGetCdtTreeItemsSchema>;
export type CdtTreeItem = z.infer<typeof CdtTreeItemSchema>;
export type ResponseGetCdtTreeItems = Pagination<CdtTreeItem>;
